/* ThinkingIndicator.tsx generated by @compiled/babel-plugin v3.0.2 */
import { ax, ix } from "@compiled/react/runtime";
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._0jFU0VoWWg%7Bheight%3A24px%7D%0A._3iDTPbQ4SZ%7Bdisplay%3Aflex%7D%0A._0aFT5v1qpb%7Bflex-direction%3Arow%7D%0A._37wbyuecOK%7Bjustify-content%3Aleft%7D%0A._3TGfC9LRg7%7Bflex-wrap%3Anowrap%7D%0A._0hPCNLDIqT%7Balign-items%3Acenter%7D%0A._2O5Vij7dHp%7Bflex-grow%3A1%7D%0A._3YEZNO7dHp%7Bflex-shrink%3A1%7D%0A._1bHrqEAEMG%7Bflex-basis%3A0%25%7D%0A._2mHwu82ADO%7Bgap%3Avar(--ds-space-100%2C8px)%7D%0A._0adFHsFQfX%7Bmargin-right%3Avar(--ds-space-025%2C2px)%7D%0A._2mHwu81Y8M%7Bgap%3Avar(--ds-space-050%2C4px)%7D%0A._0aFT5vbt8w%7Bflex-direction%3Acolumn%7D%0A._2sNsIgmnOE%7Bfont%3Avar(--ds-font-body%2Cnormal%20400%2014px%2F20px%20%22Atlassian%20Sans%22%2Cui-sans-serif%2C-apple-system%2CBlinkMacSystemFont%2C%22Segoe%20UI%22%2CUbuntu%2C%22Helvetica%20Neue%22%2Csans-serif)%7D%0A._1UtDYzy7kJ%7Bcolor%3Avar(--ds-text%2C%23292a2e)%7D%0A._3W2Oc8wPeg%7Bword-break%3Abreak-word%7D%0A._2sNsIg7NXe%7Bfont%3Avar(--ds-font-body-small%2Cnormal%20400%209pt%2F1pc%20%22Atlassian%20Sans%22%2Cui-sans-serif%2C-apple-system%2CBlinkMacSystemFont%2C%22Segoe%20UI%22%2CUbuntu%2C%22Helvetica%20Neue%22%2Csans-serif)%7D%0A._4bt5LAnQyn%7Boverflow-x%3Ahidden%7D%0A._2WAcuGnQyn%7Boverflow-y%3Ahidden%7D%0A._1ANEUSLRg7%7Bwhite-space%3Anowrap%7D%0A._4ouGXIdnbC%7Bmin-width%3A0%7D%0A._2O5VijdnbC%7Bflex-grow%3A0%7D%0A._3YEZNOdnbC%7Bflex-shrink%3A0%7D%0A._1bHrqEIZbP%7Bflex-basis%3Aauto%7D%0A._39HuIbz8Lp%7Btext-overflow%3Aellipsis%7D%0A._1BYlJISPN1%7Bmax-block-size%3A20px%7D%0A._1ANEUSzUZr%7Bwhite-space%3Anormal%7D%0A._3W2Oc84hR5%7Bword-break%3Abreak-all%7D%0A._2fwxA5Ha6T%7Btext-align%3Ajustify%7D%0A._1BYlJIey7F%7Bmax-block-size%3A1pc%7D");





























import React, { type ReactNode } from 'react';
import { fg } from '@atlaskit/platform-feature-flags/fg';
import { Box } from '@atlaskit/primitives/compiled/box';
import { ShimmerText } from '../../compact-research-steps/ShimmerText';
import { EllipsesAnimation } from '../../primitives/ellipses-animation/EllipsesAnimation';
import { MorphingShapeLoader } from '../../primitives/morphing-shape-loader/MorphingShapeLoader';
import { LazyAnimatedRovoIcon } from '../../primitives/rovo-animated-icon/LazyAnimatedRovoIcon';
const styles = {
  root: "_0jFU0VoWWg _3iDTPbQ4SZ _0aFT5v1qpb _37wbyuecOK _3TGfC9LRg7 _0hPCNLDIqT",
  rootWithAdornment: "_2O5Vij7dHp _3YEZNO7dHp _1bHrqEAEMG _2mHwu82ADO _3iDTPbQ4SZ _0aFT5v1qpb _37wbyuecOK _3TGfC9LRg7 _0hPCNLDIqT",
  iconContainer: "_2mHwu82ADO _0adFHsFQfX _3iDTPbQ4SZ _0hPCNLDIqT",
  textColumn: "_2O5Vij7dHp _3YEZNO7dHp _1bHrqEAEMG _2mHwu81Y8M _3iDTPbQ4SZ _0aFT5vbt8w",
  textRow: "_0jFU0VoWWg _3iDTPbQ4SZ _0aFT5v1qpb _0hPCNLDIqT",
  text: "_2sNsIgmnOE _1UtDYzy7kJ _3W2Oc8wPeg",
  textSmall: "_2sNsIg7NXe _1UtDYzy7kJ _3W2Oc8wPeg",
  textNoWrap: "_2sNsIgmnOE _4bt5LAnQyn _2WAcuGnQyn _1UtDYzy7kJ _1ANEUSLRg7",
  textNoWrapSmall: "_2sNsIg7NXe _4bt5LAnQyn _2WAcuGnQyn _1UtDYzy7kJ _1ANEUSLRg7",
  ellipsesContainer: "_2O5Vij7dHp _3YEZNO7dHp _1bHrqEAEMG",
  iconContainerShrinkable: "_2mHwu82ADO _0adFHsFQfX _3iDTPbQ4SZ _0hPCNLDIqT _4ouGXIdnbC",
  textColumnShrinkable: "_2O5Vij7dHp _3YEZNO7dHp _1bHrqEAEMG _2mHwu81Y8M _3iDTPbQ4SZ _0aFT5vbt8w _4ouGXIdnbC",
  iconSlot: "_2O5VijdnbC _3YEZNOdnbC _1bHrqEIZbP _3iDTPbQ4SZ _0hPCNLDIqT",
  textTruncateEllipsis: "_2sNsIgmnOE _4bt5LAnQyn _2WAcuGnQyn _1UtDYzy7kJ _4ouGXIdnbC _1ANEUSLRg7 _39HuIbz8Lp",
  textTruncateEllipsisSmall: "_2sNsIg7NXe _4bt5LAnQyn _2WAcuGnQyn _1UtDYzy7kJ _4ouGXIdnbC _1ANEUSLRg7 _39HuIbz8Lp",
  textTruncateClip: "_2sNsIgmnOE _4bt5LAnQyn _2WAcuGnQyn _1UtDYzy7kJ _4ouGXIdnbC _1BYlJISPN1 _1ANEUSzUZr _3W2Oc84hR5 _2fwxA5Ha6T",
  textTruncateClipSmall: "_2sNsIg7NXe _4bt5LAnQyn _2WAcuGnQyn _1UtDYzy7kJ _4ouGXIdnbC _1BYlJIey7F _1ANEUSzUZr _3W2Oc84hR5 _2fwxA5Ha6T",
  ellipsesContainerNoShrink: "_2O5Vij7dHp _3YEZNOdnbC _1bHrqEIZbP"
};
const getTextStyleKey = (textSize: 'default' | 'small', showEllipsis: boolean): keyof typeof styles => {
  if (textSize === 'small') {
    if (showEllipsis) {
      return 'textNoWrapSmall';
    }
    return 'textSmall';
  }
  if (showEllipsis) {
    return 'textNoWrap';
  }
  return 'text';
};
const getTruncatedTextStyleKey = (textSize: 'default' | 'small', isShowingAnimatedDots: boolean): keyof typeof styles => {
  if (isShowingAnimatedDots) {
    return textSize === 'small' ? 'textTruncateClipSmall' : 'textTruncateClip';
  }
  return textSize === 'small' ? 'textTruncateEllipsisSmall' : 'textTruncateEllipsis';
};
type RovoThinkingIndicatorProps = {
  // text shown between the Rovo icon and ellipses
  title: string;
  isAnimated?: boolean;
  // true = Rovo icon, ReactNode = custom icon (e.g. Agent avatar), false = no icon.
  // Has no effect on the morphing icon when animation is enabled — use disableMorphingAnimation for that.
  icon?: boolean | ReactNode;
  // whether to apply shimmer and loading icon animation effect to the title text
  animation?: boolean;
  // when true, suppresses the morphing animation icon and falls back to the icon prop
  disableMorphingAnimation?: boolean;
  // whether to show the ellipsis dots (default: true)
  showEllipsis?: boolean;
  // text size variant for compact surfaces
  textSize?: 'default' | 'small';
  testId?: string;
  // optional content rendered below the text (but not the icon), e.g. a progress bar
  bottomAdornment?: ReactNode;
};
const getLoadingMorphingIcon = () => {
  return <MorphingShapeLoader testId="morphing-loader" />;
};
const getIcon = (icon: ReactNode | boolean): ReactNode => {
  if (React.isValidElement(icon)) {
    return icon;
  } else if (icon) {
    return <LazyAnimatedRovoIcon alt="Rovo" testId="rovo-loading-animation" width="24px" height="24px" />;
  }
  return null;
};
export const RovoThinkingIndicator = ({
  title,
  isAnimated = true,
  icon = true,
  animation = false,
  disableMorphingAnimation = false,
  showEllipsis = true,
  textSize = 'default',
  testId,
  bottomAdornment
}: RovoThinkingIndicatorProps): JSX.Element => {
  const enableAnimation = animation;
  const isTruncationEnabled = showEllipsis && fg('rovo_thinking_indicator_text_truncation');
  const isShowingAnimatedDots = showEllipsis && isAnimated;
  const iconNode = enableAnimation && !disableMorphingAnimation ? getLoadingMorphingIcon() : getIcon(icon);
  const textStyleKey = isTruncationEnabled ? getTruncatedTextStyleKey(textSize, isShowingAnimatedDots) : getTextStyleKey(textSize, showEllipsis);
  const textNode = <Box xcss={styles[textStyleKey]}>
			{enableAnimation ? <ShimmerText size={textSize === 'small' ? 'small' : 'medium'} truncate={isTruncationEnabled && !isShowingAnimatedDots}>
					{title}
				</ShimmerText> : title}
		</Box>;
  const ellipsesNode = showEllipsis ? <Box xcss={isTruncationEnabled ? styles.ellipsesContainerNoShrink : styles.ellipsesContainer}>
			<EllipsesAnimation isAnimated={isAnimated} />
		</Box> : null;
  if (bottomAdornment) {
    return <Box xcss={styles.rootWithAdornment} testId={testId}>
				<Box xcss={styles.iconContainer}>{iconNode}</Box>
				<Box xcss={isTruncationEnabled ? styles.textColumnShrinkable : styles.textColumn}>
					<Box xcss={styles.textRow}>
						{textNode}
						{ellipsesNode}
					</Box>
					{bottomAdornment}
				</Box>
			</Box>;
  }
  if (isTruncationEnabled) {
    return <Box xcss={styles.root} testId={testId}>
				<Box xcss={styles.iconContainerShrinkable}>
					{iconNode ? <Box xcss={styles.iconSlot}>{iconNode}</Box> : null}
					{textNode}
				</Box>
				{ellipsesNode}
			</Box>;
  }
  return <Box xcss={styles.root} testId={testId}>
			<Box xcss={styles.iconContainer}>
				{iconNode}
				{textNode}
			</Box>
			{ellipsesNode}
		</Box>;
};